import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_READY_TO_SHARE_FCM = defineFcm(
	'starter_experience_dashboard_ready_to_share_fcm',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
				generatePredraftedPosts: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({
		experimentName: undefined,
		generatePredraftedPosts: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Shows a Pre-made post module only to US users',
		import: false,
		template: {
			experimentName: undefined,
		},
	});
